import React from "react";
import { Label } from "@/components/ui/label";

export function StatusBadge({ estado }) {
  const map = {
    generado:   "status-generado",
    modificado: "status-modificado",
    anulado:    "status-anulado",
    borrador:   "status-borrador",
  };
  const cls = map[estado] || "status-borrador";
  const label = { generado: "Generado", modificado: "Modificado", anulado: "Anulado", borrador: "Borrador" }[estado] || estado;
  return <span className={`status-badge ${cls}`} data-testid={`estado-${estado}`}>{label}</span>;
}

export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6" data-testid={testid}>
      <div>
        <div className="label-tag">DeCA</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Chivo" }}>{title}</h1>
        {subtitle ? <p className="text-slate-500 mt-1 text-sm sm:text-base max-w-2xl">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}

export function Field({ id, label, children, className }) {
  const auto = React.useId();
  const fid = id || auto;
  const kid = React.Children.only(children);
  const child = React.isValidElement(kid)
    ? React.cloneElement(kid, {
        id: kid.props.id || fid,
        "aria-label": kid.props["aria-label"] || (typeof label === "string" ? label : undefined),
      })
    : kid;
  const max = React.isValidElement(child) ? child.props.maxLength : undefined;
  const val = React.isValidElement(child) ? child.props.value : undefined;
  const n = typeof val === "string" && typeof max === "number" ? val.length : null;
  return (
    <div className={className}>
      <div className="flex items-center justify-between gap-2 min-h-7">
        <Label htmlFor={fid} className="label-tag">{label}</Label>
        {n != null ? <span className="text-[10px] font-mono text-slate-400 tabular-nums">{n}/{max}</span> : null}
      </div>
      {child}
    </div>
  );
}

export function KV({ label, value, mono, testid }) {
  return (
    <div>
      <div className="label-tag">{label}</div>
      <div className={`text-sm text-slate-900 mt-0.5 ${mono ? "font-mono text-xs" : ""}`} data-testid={testid}>{value ?? "—"}</div>
    </div>
  );
}
